import { Trailer } from "../../../images"
import { useState, useEffect } from "react"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { useTranslation } from "react-i18next"

const GateLinkTrailer = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [disabledProceedTrailer, setdisabledProceedTrailer] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [TrailerNumber, setTrailerNumber] = useState("")
  const [invalidPhone, setinvalidPhone] = useState(false)

  const assetReducer = useSelector((state: RootState) => state.assetReducer)

  const setTrailer = () => {
    let asset = {
      ...assetReducer.asset,
      trailer: TrailerNumber
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })
    history.push("/event-tracking")
  }

  const handlePaste = (limit: number) => {
    let truncatTrailerNumber = TrailerNumber.substring(0, limit)
    setTrailerNumber(truncatTrailerNumber)
  }
  useEffect(() => {
    if (TrailerNumber.trim().length > 0) {
      setdisabledProceedTrailer(false)
    } else {
      setdisabledProceedTrailer(true)
    }
  }, [TrailerNumber])

  const trailer_not_valid = t("trailer_not_valid")

  return (
    <>
      <div className="truck-container">
        <div className="truck-header-text">{t("enter_trailer_number")}</div>
        <div
          className={`driver-input driver-input-USDOT-font ${
            invalidPhone ? "error-label" : ""
          }`}
        >
          <Input
            autoFocus={true}
            className={`${invalidPhone ? "error-label" : ""}`}
            placeholder={t("enter_trailer_here")}
            label=""
            value={TrailerNumber}
            maxLength={20}
            disabled={disabledPhone}
            hideLabel={false}
            invalid={invalidPhone}
            onChange={event => setTrailerNumber(event.target.value)}
            onPaste={e => handlePaste(20)}
            errorLabel={invalidPhone ? trailer_not_valid : ""}
            icon={
              invalidPhone ? (
                <AlertIcon className="elemental-Input-icon--invalid" />
              ) : (
                <></>
              )
            }
          />
        </div>
        <img src={Trailer} />
        <div className="info"></div>
      </div>
      <BottomBar
        disabled={disabledProceedTrailer}
        onClick={() => setTrailer()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default GateLinkTrailer
